module.exports = __webpack_public_path__ + "assets/word_data.18cd8a3a.svg";